import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PropertyDetails from './PropertyDetails';
import { doSearch, selectProperty, setSearchedAddress } from './propertyDetailsActions';
import { getBestOffers } from '../SelectBestOffer/selectBestOfferActions';

function PropertyDetailsContainer(props) {
    return (
        <PropertyDetails
            setStep={props.setStep}
            setStepCompleted={props.setStepCompleted}
            setSearchedAddress={props.setSearchedAddress}
            searchedAddress={props.searchedAddress}
            doSearch={props.doSearch}
            propertyList={props.propertyList}
            searchInProgress={props.searchInProgress}
            selectProperty={props.selectProperty}
            selectedProperty={props.selectedProperty}
            getBestOffers={props.getBestOffers}
            applicationType={props.applicationType}
            applicantsIncome={props.applicantsIncome}
            mortgageType={props.mortgageType}
            estaminatedPropertyValue={props.estaminatedPropertyValue}
            estaminatedPropertyMonthlyRent={props.estaminatedPropertyMonthlyRent}
            requestedLoanAmount={props.requestedLoanAmount}
            requestedTimeSpan={props.requestedTimeSpan}
            customer={props.customer}
        />
    );
}

const mapStateToProps = state => ({
    searchedAddress: state.propertyDetailsReducer.searchedAddress,
    propertyList: state.propertyDetailsReducer.propertyList,
    searchInProgress: state.propertyDetailsReducer.searchInProgress,
    selectedProperty: state.propertyDetailsReducer.selectedProperty,
    applicationType: state.quickQuoteReducer.applicationType,
    applicants: state.quickQuoteReducer.applicants,
    mortgageType: state.quickQuoteReducer.mortgageType,
    applicantsIncome: state.quickQuoteReducer.applicantsIncome,
    estaminatedPropertyValue: state.quickQuoteReducer.property.estaminatedPropertyValue,
    estaminatedPropertyMonthlyRent: state.quickQuoteReducer.property.estaminatedPropertyMonthlyRent,
    requestedLoanAmount: state.quickQuoteReducer.requestedLoanAmount,
    requestedTimeSpan: state.quickQuoteReducer.requestedTimeSpan,
    customer: state.customerReducer,
});

const mapDispatchToProps = dispatch => ({
    setSearchedAddress: (event) => {
        dispatch(setSearchedAddress(event));
    },
    doSearch: () => {
        dispatch(doSearch());
    },
    selectProperty: (property) => {
        dispatch(selectProperty(property));
    },
    getBestOffers: (props) => {
        dispatch(getBestOffers(props));
    },
});

PropertyDetailsContainer.propTypes = {
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    setSearchedAddress: PropTypes.func.isRequired,
    searchedAddress: PropTypes.string.isRequired,
    doSearch: PropTypes.func.isRequired,
    propertyList: PropTypes.array.isRequired,
    searchInProgress: PropTypes.bool.isRequired,
    selectProperty: PropTypes.func.isRequired,
    selectedProperty: PropTypes.object.isRequired,
    getBestOffers: PropTypes.func.isRequired,
    applicationType: PropTypes.string.isRequired,
    mortgageType: PropTypes.string.isRequired,
    applicantsIncome: PropTypes.array.isRequired,
    estaminatedPropertyValue: PropTypes.object.isRequired,
    estaminatedPropertyMonthlyRent: PropTypes.object.isRequired,
    requestedLoanAmount: PropTypes.object.isRequired,
    requestedTimeSpan: PropTypes.number.isRequired,
    customer: PropTypes.object.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(PropertyDetailsContainer);



// WEBPACK FOOTER //
// ./src/app/FormStepper/PropertyDetails/PropertyDetailsContainer.js